module.exports = __webpack_public_path__ + "static/media/signage-industrial-img28.4451a857.jpg";